export default __webpack_public_path__ + "static/media/booking.268bd9e9.png";